import React from 'react';

import bgImg from '../../../assets/img/wood-presents-r.jpg';

function Footer() {
  return (
    <div className="kt-footer kt-grid__item" style={{backgroundImage: "url(" + bgImg + ")", backgroundPosition:"bottom"}} id="kt_footer">
        <div className="kt-container ">
            <div className="kt-footer__top">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="kt-footer__section">
                            <h3 className="kt-footer__title">About</h3>
                            <div className="kt-footer__about text-white">
                                We started this website over 8 years ago and it's been amazing to watch it grow every year. Best wishes and "Merry Christmas" from Julie and Andrew Stewart.<br/><br/>
                                As an Amazon Associate we earn from qualifying purchases.
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="kt-footer__section">
                            <h3 className="kt-footer__title">Mobile App</h3>
                            <div className="row">
                                <div className="col">
                                    <a href="https://itunes.apple.com/us/app/the-christmas-list-app/id1438673722?ls=1&amp;mt=8">
                                        <img alt="itune" src="https://weblight.imgix.net/ios_store_badge.png" style={{height: "50px", margin: "4px"}} />
                                    </a>

                                    <a href="https://play.google.com/store/apps/details?id=com.christmaslistapp.weblight&amp;hl=en">
                                        <img alt="googleplay" src="https://weblight.imgix.net/google-play-badge.png" style={{height: "50px", margin: "4px"}} />
                                    </a>
                                </div>
                                <div className="col">
                                    <ul className="kt-footer__nav">
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="kt-footer__section">
                            <h3 className="kt-footer__title">Social Links</h3>
                            <div className="kt-footer__social">
                                <ul className="kt-footer__social-nav">
                                    <li><a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/christmaslistapp"><i className="flaticon-facebook-logo-button text-white"></i></a></li>
                                    <li><a rel="noopener noreferrer" taget="_blank" href="https://twitter.com/XmasListApp"><i className="flaticon-twitter-logo-button text-white"></i></a></li>
                                    <li><a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/christmaslistapp/"><i className="flaticon-instagram-logo text-white"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-footer__bottom">
                <div className="kt-footer__copyright text-white">
                    2020&nbsp;&copy;&nbsp;<a href="https://www.christmaslistapp.com" target="_blank" rel="noopener noreferrer" className="text-white">ChristmasListApp.com</a>
                </div>
            </div>
        </div>
    </div>


  );
}

export default Footer;
